import { TROVIT_NEWSLETTERS, PARTNERS_NEWSLETTERS } from './constants';

export default {
  [TROVIT_NEWSLETTERS]: null,
  [PARTNERS_NEWSLETTERS]: null,
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/NewsletterNotifications/initialState.js